"use client";

import { useLocale } from "next-intl";

interface LoginLinkProps {
  className?: string;
  children: React.ReactNode;
}

export default function LoginLink({ className, children }: LoginLinkProps) {
  const locale = useLocale();

  const handleClick = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    const cookieDomain = "." + window.location.hostname;
    document.cookie = `KEYCLOAK_LOCALE=${locale}; path=/; max-age=31536000; Secure; SameSite=Lax; domain=${cookieDomain}`;
    window.location.href = "/auth/login";
  };

  return (
    <a href="/auth/login" onClick={handleClick} className={className}>
      {children}
    </a>
  );
}
